import {
    SET_ESS_KW,
    SET_ESS_KWH,
    SET_ESS_PRICE,
    SET_MADE_IN_CA,
    SET_INCLUDE_ESS,
    SET_BATTERY_TYPE,
    SET_ESS,
} from './constants';

const defaultState = {
    esskW: 8,
    esskWh: 10,
    essPrice: 14975,
    madeInCA: false,
    includeESS: true,
    batteryType: 'fortress10',
};

const ess = (state = defaultState, action) => {
    switch (action.type) {
        case SET_ESS_KW:
            return { ...state, esskW: action.esskW };

        case SET_ESS_KWH:
            return { ...state, esskWh: action.esskWh };

        case SET_ESS_PRICE:
            return { ...state, essPrice: action.essPrice };

        case SET_MADE_IN_CA:
            return { ...state, madeInCA: action.madeInCA };

        case SET_INCLUDE_ESS:
            return { ...state, includeESS: action.includeESS };

        case SET_BATTERY_TYPE:
            return { ...state, batteryType: action.batteryType };

        case SET_ESS:
            return {
                includeESS: action.ess.includeInSimulation,
                batteryType: action.ess.batteryType,
                esskW: action.ess.storageKw,
                esskWh: action.ess.storageKwh,
                essPrice: action.ess.price,
                madeInCA: action.ess.madeInCa,
            };

        default:
            return state;
    }
};

export default ess;



// WEBPACK FOOTER //
// ./src/containers/common/ess/reducer.js